import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type WatchInvoiceCreditsSubscriptionVariables = Types.Exact<{
  invoiceId: Types.Scalars['bigint']['input'];
}>;


export type WatchInvoiceCreditsSubscription = { __typename?: 'subscription_root', arcredits_aggregate: { __typename?: 'arcredits_aggregate', aggregate?: { __typename?: 'arcredits_aggregate_fields', count: number, sum?: { __typename?: 'arcredits_sum_fields', amount?: number | null } | null } | null } };


export const WatchInvoiceCreditsDocument = gql`
    subscription watchInvoiceCredits($invoiceId: bigint!) {
  arcredits_aggregate(
    where: {active: {_eq: true}, argroup: {arinvoice_id: {_eq: $invoiceId}}}
  ) {
    aggregate {
      count
      sum {
        amount
      }
    }
  }
}
    `;

/**
 * __useWatchInvoiceCreditsSubscription__
 *
 * To run a query within a React component, call `useWatchInvoiceCreditsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchInvoiceCreditsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchInvoiceCreditsSubscription({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useWatchInvoiceCreditsSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchInvoiceCreditsSubscription, WatchInvoiceCreditsSubscriptionVariables> & ({ variables: WatchInvoiceCreditsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchInvoiceCreditsSubscription, WatchInvoiceCreditsSubscriptionVariables>(WatchInvoiceCreditsDocument, options);
      }
export type WatchInvoiceCreditsSubscriptionHookResult = ReturnType<typeof useWatchInvoiceCreditsSubscription>;
export type WatchInvoiceCreditsSubscriptionResult = Apollo.SubscriptionResult<WatchInvoiceCreditsSubscription>;